<div *ngIf="currentTheme$ | async as currentTheme" class="flex-center container">
  <div class="po-mb-3 flex-center">
    <img
      class="po-mb-2 logo-img"
      [src]="currentTheme.imageUrls.companyLogoUrl"
      [alt]="currentTheme.labels.appTitle | translate"
    />

    <h1 class="po-page-header-title text-align-center">{{ currentTheme.labels.simpleAppTitle | translate }}</h1>
  </div>

  <h2 class="po-mb-2">{{ 'l-email-verification-subtitle' | translate }}</h2>

  @if (isLoadingState()) {
    <div class="po-mb-1">
      <ats-lib-spin-loader [absolute]="false"></ats-lib-spin-loader>
    </div>

    <p class="po-mb-1">{{ 'l-email-verification-message-loading-1' | translate }}</p>

    <p class="text-align-center">{{ 'l-email-verification-message-loading-2' | translate }}</p>
  } @else {
    <ats-alert-display
      *ngIf="isSuccessState()"
      class="po-sm-12 po-md-8 po-lg-5 po-xl-3"
      theme="information"
      containerMargin="0 0 8px 0"
    >
      {{ 'l-email-verification-message-success-1' | translate }}
    </ats-alert-display>

    <p class="po-mb-1 text-align-center">
      <span [innerHTML]="'l-email-verification-message-success-2' | translate"></span>
      <strong class="countdown" [@changeCountdown]="countdownSeconds()">{{ countdownSeconds() }}</strong>
      {{ (countdownSeconds() === 1 ? 'l-second' : 'l-seconds') | translate }}.
    </p>

    <po-button
      class="po-sm-12 po-md-6 po-lg-3 po-mt-1"
      [p-label]="'l-back-to-login' | translate"
      p-kind="tertiary"
      (p-click)="goToRedirectUrlOrHome()"
      data-cy="go-to-login-button"
    ></po-button>
  }
</div>
